import { render } from "./menu-shelf.vue?vue&type=template&id=2916eef4"
import script from "./menu-shelf.vue?vue&type=script&lang=js"
export * from "./menu-shelf.vue?vue&type=script&lang=js"

import "./menu-shelf.vue?vue&type=style&index=0&id=2916eef4&lang=scss"

import exportComponent from "/Users/andrewamistad/Sites/lyle-and-scott/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__